import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-member",
  "use": "icon-member-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-member\">\n    <path d=\"M77.9 224.26a15 15 0 1 0 15 15 15.017 15.017 0 0 0-15-15zm0 5.933a4.672 4.672 0 1 1-4.672 4.672 4.672 4.672 0 0 1 4.672-4.672zm0 23.158a14.062 14.062 0 0 1-11-5.311c.71-3.109 5.38-5.532 11-5.532 5.623 0 10.293 2.423 11 5.532a14.062 14.062 0 0 1-11 5.311z\" transform=\"translate(-62.896 -224.26)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol